import type { Dispatch, SetStateAction } from "react";

import { EllipsisDropdownItem, Tooltip } from "@similarweb/ui-components";

import * as SC from "./styles";

type CountryItemSchema = {
    code: number;
    name: string;
    id: string;
    selectedCountry: number;
    isTooltipEnabled: boolean;
    activeId?: string;
    setCode: Dispatch<SetStateAction<number>>;
    onClose: () => void;
};

export const CountryItem = ({
    code,
    name,
    selectedCountry,
    isTooltipEnabled,
    id,
    activeId,
    setCode,
    onClose,
}: CountryItemSchema) => {
    const onClick = () => {
        setCode(code);
        onClose();
    };

    return (
        <SC.ItemContainer
            isActive={activeId === id}
            onClick={onClick}
        >
            <EllipsisDropdownItem
                key={name}
                id={id}
                text={name}
                countryCode={code}
                selected={selectedCountry === code}
            >
                <Tooltip
                    content={name}
                    enabled={isTooltipEnabled}
                >
                    <SC.CountryNameWrapper>{name}</SC.CountryNameWrapper>
                </Tooltip>
            </EllipsisDropdownItem>
        </SC.ItemContainer>
    );
};
